export default {
      id: "social-vk-usage",
      viewBox: "0 0 22 13",
      url: __webpack_public_path__ + "img/icons.svg#social-vk",
      toString: function () {
        return this.url;
      }
    }